import { createContext, useState } from "react";

export const CreateAccountContext = createContext();

export const CreateAccountProvider = ({ children }) => {
  const [verifyEmail, setVerifyEmail] = useState("");

  return (
    <CreateAccountContext.Provider value={{ verifyEmail, setVerifyEmail }}>
      {children}
    </CreateAccountContext.Provider>
  );
};
